import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
import { useSettingsStore } from '@/store/modules/settings';

import { inject } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const $pub = inject('$pub');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const handleOpenTheme = () => {
      $pub('theme');
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      return _unref(theme).showTheme ? (_openBlock(), _createElementBlock("span", _hoisted_1, [_createVNode(_component_vab_icon, {
        icon: "brush-2-line",
        onClick: handleOpenTheme
      })])) : _createCommentVNode("", true);
    };
  }
});